import { Colors } from '../../consts/Colors';
import { tags } from '../../consts/Tags';

export default class Zone2 extends Phaser.GameObjects.Container {
    constructor(scene, zoneData) {
        super(scene, zoneData.zoneX, zoneData.zoneY, []);

        scene.add.existing(this);
        this.scene = scene;
        this.zoneId = zoneData.zoneId
        this.zoneCarteId = zoneData.index
        this.isCorrect = false;

        this.dropZone = this.scene.add.image(0, 0, zoneData.image).setOrigin(0.5);
        this.add(this.dropZone);
 
    }

    setActive() {
        this.dropZone.setTint(0xFFFFFF);
        this.setSize(this.dropZone.width, this.dropZone.height);
        this.setInteractive({ dropZone: true });
    }

    addDeck(deck) {
        this.deck = deck;
    }

    setNormal() {
        this.dropZone.setTint(0xFFFFFF);
    }

    setWrong() {
        this.dropZone.setTint(0xEF3C24);
        this.disableInteractive()
    }

    setCorrect() {
        this.dropZone.setTint(0x7ED321);
        this.isCorrect = true;
    }

    reset(){
        if(!this.isCorrect){
            this.setInteractive({ dropZone: true })
            this.setNormal()
        }
    }

    onPointerOver() {
        this.dropZone.setTint(0x777777);
    }
    onPointerOut() {
        this.dropZone.setTint(0xFFFFFF);
    }
    dragOnPointerOver() {
        this.dropZone.setTint(0x777777);
    }
    dragOnPointerOut() {
        this.dropZone.setTint(0xFFFFFF);
    }

    

    
}